import React from "react";

const PdfPreview = ({ base64Pdf }) => {
  const pdfSrc = `data:application/pdf;base64,${base64Pdf}`;

  return (
    <iframe
      src={pdfSrc}
      title="PDF Preview"
      width="100%"
      height="600px"
      style={{ border: "none" }}
    />
  );
};

export default PdfPreview;
